import React from "react";

import { i18n } from "../../translate/i18n";
import noTickets from "../../assets/noTickets.png";

export default function TicketsWelcome({ tailwickLayout = false }) {
	if (tailwickLayout) {
		return (
			<div className="flex h-full flex-col items-center justify-center px-8 text-center">
				<img
					src={noTickets}
					alt=""
					className="mb-6 max-h-48 w-auto opacity-90"
				/>
				<h2 className="mb-2 text-lg font-semibold text-default-800">
					{i18n.t("chat.noChatDescription")}
				</h2>
				<p className="max-w-md text-sm text-default-500">
					{i18n.t("chat.noChatDescriptionText")}
				</p>
				<p className="mt-6 text-xs text-default-400">
					{i18n.t("chat.layout.selectConversationHint")}
				</p>
			</div>
		);
	}

	return (
		<div
			className="flex h-full flex-col items-center justify-center bg-white text-center dark:bg-default-900"
			style={{ borderRadius: 0 }}
		>
			<img src={noTickets} alt="illustration-no-tickets" className="mb-4" />
			<h1 className="text-lightgray" style={{ color: "lightgray" }}>
				{process.env.REACT_APP_NOME}
			</h1>
			<p className="text-[#999]">{i18n.t("chat.noChatDescription")}</p>
			<p className="text-[#999]">{i18n.t("chat.noChatDescriptionText")}</p>
		</div>
	);
}
